import React from 'react';

import { BigLoader } from '../../atoms/Loader/StyledBigLoader';

const Loader = ({ declaredWidth, declaredHeight }) => {
    return <BigLoader width={declaredWidth} height={declaredHeight} />;
};

export default Loader;
